import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint = 550) => {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };
        // Call once on mount
        handleResize();
        window.addEventListener('resize', handleResize);
        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakpoint]); // Re-run only if breakpoint changes

    return isMobile;
};
export default useIsMobile;
